module.exports = "<div ng-class=\"{\n  container: !$$setting.data.general.checkboxs.largeMode.model, \n  largeContainer: $$setting.data.general.checkboxs.largeMode.model\n}\">\n  <div class=\"section\"\n    ui-view>\n\n  </div>\n\n  <div class=\"center\">\n    <my-button my-label=\"$root.labels.back\"\n      my-icon=\"$root.icons.back\"\n      my-style=\"$root.styles.dark()\"\n      my-click=\"$root.$back()\">\n    </my-button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/account/templates/index.html
// module id = 1471
// module chunks = 0